import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.ConfirmConvertCurrencyPopupContent', {
    review: 'Review',
    checkAndConfirm: 'Please check the data and confirm the conversion',
    from: 'From',
    to: 'To',
    wallet: 'Wallet:',
    sell: 'Sell:',
    buy: 'Buy:',
    exchangeRate: 'Exchange rate:',
    exchangeRateValue: '1 {fromCurrency} = {rate} {toCurrency}',
    date: 'Date:',
    todayAt: 'Today at {time}',
    note: 'Please note that exchange rate may deviate slightly based on the current market situation.',
    back: 'Back',
    confirm: 'Confirm',
    success: 'Conversion successfully submitted. Wallets balances will be updated soon.',
});
